/**
 * Pop-up platform preferences window (`workbench.openSettings`, alias
 * `workbench.openSettingsWindow`).
 * Content size is 1160×833. The Figma artboard around `9229:191444` is larger
 * because it includes the surrounding canvas.
 *
 * Not a contributed module view — DetachedSurface special-cases this handle so
 * the shell can open a bare window without activating a module UI. The handle
 * itself lives in `@hibro/shared` so the host can close it without this package.
 */
// `export { X } from` does not bind X here; this function reads both names.
import {
  SETTINGS_WINDOW_FRAGMENT_ID,
  SETTINGS_WINDOW_VIEW_ID,
} from '@hibro/shared';

export { SETTINGS_WINDOW_FRAGMENT_ID, SETTINGS_WINDOW_VIEW_ID };
/** Platform settings popup width, bare pixels (no token). */
export const SETTINGS_WINDOW_WIDTH = 1160;
/** Platform settings popup height, bare pixels (no token). */
export const SETTINGS_WINDOW_HEIGHT = 833;

export function isSettingsWindowSurface(
  viewId: string,
  fragmentId: string | undefined,
): boolean {
  return (
    viewId === SETTINGS_WINDOW_VIEW_ID &&
    fragmentId === SETTINGS_WINDOW_FRAGMENT_ID
  );
}
